import { useState } from 'react';
import { TSizes } from '../constants/sizes';

export const GlassContainer = ({
  children,
  width = '100%',
  height = 'auto',
  radius = TSizes.radiusPill || 24,
  clickable = false,
  style = {}
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      onMouseEnter={() => clickable && setIsHovered(true)}
      onMouseLeave={() => clickable && setIsHovered(false)}
      style={{
        position: 'relative',
        width: width,
        height: height,
        borderRadius: `${radius}px`,
        background: 'transparent',
        backdropFilter: 'blur(8px)',
        WebkitBackdropFilter: 'blur(8px)',
        border: '1px solid rgba(255, 255, 255, 0.25)',
        boxShadow: 'inset 0 0 0 1px rgba(255, 255, 255, 0.1)',
        transform: isHovered ? 'scale(1.012)' : 'scale(1)',
        transition: 'transform 0.25s cubic-bezier(0.16, 1, 0.3, 1)',
        boxSizing: 'border-box',
        display: 'inline-block',
        ...style
      }}
    >
      <div style={{ position: 'relative', zIndex: 2, width: '100%', height: '100%' }}>
        {children}
      </div>
    </div>
  );
};
